// extracted by mini-css-extract-plugin
module.exports = {"lesson":"Lesson_lesson__S5nnM","topic-list":"Lesson_topic-list__q_cer","h1-title":"Lesson_h1-title__12Yjb"};